"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kansaTargetListReducer = exports.kansaTargetListActions = exports.TYPES = exports.PERMISSION_KEY_EDIT = exports.CONTENTS = void 0;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'Search';

// コンテンツタイプ
const CONTENTS = exports.CONTENTS = {
  SEARCH: 'search',
  // 監査対象事業一覧
  REGISTER: 'register' // 監査対象事業登録
};

// 権限制御(編集権限)
const PERMISSION_KEY_EDIT = exports.PERMISSION_KEY_EDIT = 'edit';

// 初期状態
const INIT_STATE = {
  // 検索結果一覧先頭
  searchResultPosition: {},
  // コンテナ情報(画面遷移制御に使用)
  containerInfo: {
    dispContent: CONTENTS.SEARCH
  },
  // 監査対象年度
  selectNendo: {
    kansaTgtNendo: '',
    kansaTgtTheme: '',
    preparation: ''
  },
  // 監査情報(監査対象事業登録への遷移時に渡すKey情報)
  kansaInfo: {
    kansaTgtNendo: '',
    kansaTgtJigyoId: ''
  },
  // 検索条件
  searchConditions: {
    // 監査対象年度
    kansaTgtNendo: '',
    kansaTgtTheme: '',
    // 監査部門(会社CD、組織CD、名称)
    kansaKaishaCd: '',
    kansaBumonCd: '',
    kansaBumonNm: '',
    // 被監査部門(会社CD、組織CD、名称)
    hikansaKaishaCd: '',
    hikansaBumonCd: '',
    hikansaBumonNm: '',
    // 監査対象事業
    kansaTgtJigyoNm: '',
    // 監査部門が未設定の監査対象事業のみ表示
    kansabumonBlankFilter: false,
    // 被監査部門が未設定の監査対象事業のみ表示
    hikansabumonBlankFilter: false,
    // 監査部門責任者（姓名）
    kansabumonChiefName: '',
    // 監査部門担当者（姓名）
    kansabumonTantoName: '',
    // 被監査部門責任者（姓名）
    hikansabumonChiefName: '',
    // 被監査部門担当者（姓名）
    hikansabumonTantoName: ''
  },
  // 検索条件(保持用)
  searchConditionsSave: {},
  // 検索結果情報
  searchResultCtrl: {
    // 検索結果一覧
    searchResult: [],
    // 一覧のスクロール位置
    scrollTop: {
      index: 0,
      scrollY: 0,
      noSticky: false
    },
    // 一覧のページ情報
    paging: {
      viewNum: 50,
      currentPage: 0
    },
    // すべて表示
    showAll: false
  },
  // 選択情報制御
  selectCtrl: {
    kansaChiefCheckBox: {},
    kansaTantoCheckBox: {},
    hikansaChiefCheckBox: {},
    hikansaTantoCheckBox: {},
    // チェックボックス状態(監査責任者選択)
    kansaChiefCheckBoxStatus: {},
    // チェックボックス状態(監査担当者選択)
    kansaTantoCheckBoxStatus: {},
    // チェックボックス状態(被監査担当者選択)
    hikansaChiefCheckBoxStatus: {},
    // チェックボックス状態(被監査責任者選択)
    hikansaTantoCheckBoxStatus: {}
  },
  // 削除チェックボックスリスト
  deleteCheckBoxList: {},
  // 責任者／担当者　登録リスト
  insertDataList: {},
  // 責任者／担当者　削除リスト
  deleteDataList: {},
  // 再検索を行うどうか
  doSearch: false,
  reload: false
};
const TYPES = exports.TYPES = {
  // 検索条件変更
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  // 検索結果一覧設定
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  // スクロール位置を変更
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  // ページ変更
  CHANGE_PAGE: PREFIX + 'ChangePage',
  // １ページの表示件数を変更
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  // 監査対象事業一覧
  GO_MAIN: PREFIX + 'GoMain',
  // 監査対象事業登録
  GO_REGISTER: PREFIX + 'GoRegister',
  // 初期状態にする
  CLEAR: PREFIX + 'Clear',
  // 組織名の表示切替
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  // 行データ削除チェックボックスの状態変更
  CHANGE_DELETE_CHECK_BOX: PREFIX + 'ChangeDeleteCheckBox',
  // 行データ削除
  DELETE: PREFIX + 'Delete',
  // 責任者／担当者 選択
  SELECT_USER: PREFIX + 'SelectUser',
  // 責任者／担当者 削除
  DELETE_USER: PREFIX + 'DeleteUser',
  // 責任者／担当者 更新
  SET_USERS: PREFIX + 'SetUser',
  // 年度選択変更
  CHANGE_NENDO: PREFIX + 'ChangeNendo',
  // 初期値を返却
  SET_INITIAL_VALUE: PREFIX + 'SetInitialValue',
  // 共有検索条件設定
  APPLY_SHARE_CONDITION: PREFIX + 'ApplyShareCondtion',
  //
  CHANGE_RELOAD: PREFIX + 'ChangeReload'
};
const kansaTargetListActions = exports.kansaTargetListActions = (0, _reduxActions.createActions)({
  // 検索条件変更
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 検索結果一覧設定
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 登録／更新内容を項目ごとに設定
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // スクロール位置を変更
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // ページ変更
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // １ページの表示件数を変更
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 監査対象事業一覧画面遷移
  [TYPES.GO_MAIN]: function () {
    return {
      doSearch: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 組織名の表示切替
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 行データ削除チェックボックスの状態変更
  [TYPES.CHANGE_DELETE_CHECK_BOX]: function () {
    return {
      checked: arguments.length <= 0 ? undefined : arguments[0],
      key: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 行データ削除実行
  [TYPES.DELETE]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 責任者／担当者 選択
  [TYPES.SELECT_USER]: function () {
    return {
      kansaTgtNendo: arguments.length <= 0 ? undefined : arguments[0],
      kansaTgtJigyoId: arguments.length <= 1 ? undefined : arguments[1],
      tantoKbn: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  // 責任者／担当者 削除
  [TYPES.DELETE_USER]: function () {
    return {
      kansaTgtNendo: arguments.length <= 0 ? undefined : arguments[0],
      kansaTgtJigyoId: arguments.length <= 1 ? undefined : arguments[1],
      user: arguments.length <= 2 ? undefined : arguments[2],
      tantoKbn: arguments.length <= 3 ? undefined : arguments[3]
    };
  },
  // 責任者／担当者選択
  [TYPES.SET_USERS]: function () {
    return {
      user: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 監査対象年度変更
  [TYPES.CHANGE_NENDO]: function () {
    return {
      nendo: arguments.length <= 0 ? undefined : arguments[0],
      theme: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // (監査対象年度の)初期値を返却
  [TYPES.SET_INITIAL_VALUE]: function () {
    return {
      nendo: arguments.length <= 0 ? undefined : arguments[0],
      theme: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 監査対象事業登録へ遷移
  [TYPES.GO_REGISTER]: function () {
    return {
      kansaInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.APPLY_SHARE_CONDITION]: function () {
    return {
      searchConditions: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_RELOAD]: function () {
    return {
      reload: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
},
// 初期状態にする
TYPES.CLEAR);

/**
 *  担当者 位置取得処理
 * @param {*} list 監査部門担当者、または被監査部門担当者のリスト
 * @param {*} user 担当者
 */
function getRowIndex(list, user) {
  if (null !== list) {
    for (let i = 0; i < list.length; i++) {
      if (equals(list[i], user)) {
        return i;
      }
    }
  }
  return -1;
}

/**
 * 責任者／担当者 情報比較処理
 * @param {*} lhs 左辺値(left  hand side)
 * @param {*} rhs 右辺値(right hand side)
 */
function equals(lhs, rhs) {
  if (lhs === null || rhs === null) {
    return false;
  }
  return JSON.stringify(lhs) === JSON.stringify(rhs);
}

/**
 * 属性付与処理
 */
function attachProperty() {
  return {
    kansabumonChief: null,
    kansabumonTantoList: [],
    hikansabumonChief: null,
    hikansabumonTantoList: []
  };
}

/**
 * 無効項目削除処理
 * @param {*} argList 削除対象となるリスト
 */
function sweep(argList) {
  // [監査部門、被監査部門]の[責任者、担当者]が未設定の項目を削除対象リストに追加する。
  let blankItems = [];
  Object.keys(argList).forEach(function (key) {
    if (argList[key].kansabumonChief === null && argList[key].kansabumonTantoList.length === 0 && argList[key].hikansabumonChief === null && argList[key].hikansabumonTantoList.length === 0) {
      blankItems.push(key);
    }
  });

  // 削除対象リストの項目を削除する。
  blankItems.forEach(key => delete argList[key]);
}
const kansaTargetListReducer = exports.kansaTargetListReducer = (0, _reduxActions.handleActions)({
  // 検索条件変更
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  // 検索結果一覧設定
  [TYPES.SET_SEARCH_RESULT]: (state, action) => {
    // チェックボックス状態リストの状態を全てOFF(false)で初期化する。
    const data = Object.assign({}, action.payload.searchResult);
    const newCheckBoxStatusList = {};
    Object.values(data).forEach(function (value) {
      newCheckBoxStatusList[value.kansaTgtNendo + ',' + value.kansaTgtJigyoId] = false;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchConditionsSave: JSON.parse(JSON.stringify(state.searchConditions)),
      searchResultCtrl: _objectSpread(_objectSpread({}, state.searchResultCtrl), {}, {
        searchResult: action.payload.searchResult,
        paging: Object.assign({}, INIT_STATE.searchResultCtrl.paging)
      }),
      selectCtrl: {
        kansaChiefCheckBox: {},
        kansaTantoCheckBox: {},
        hikansaChiefCheckBox: {},
        hikansaTantoCheckBox: {},
        kansaChiefCheckBoxStatus: newCheckBoxStatusList,
        kansaTantoCheckBoxStatus: newCheckBoxStatusList,
        hikansaChiefCheckBoxStatus: newCheckBoxStatusList,
        hikansaTantoCheckBoxStatus: newCheckBoxStatusList
      },
      insertDataList: {},
      deleteDataList: {},
      deleteCheckBoxList: {},
      doSearch: false,
      reload: false
    });
  },
  // スクロール位置を変更
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResultCtrl: _objectSpread(_objectSpread({}, state.searchResultCtrl), {}, {
        scrollTop: action.payload.scrollTop
      })
    });
  },
  // ページ変更
  [TYPES.CHANGE_PAGE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResultCtrl: _objectSpread(_objectSpread({}, state.searchResultCtrl), {}, {
        paging: _objectSpread(_objectSpread({}, state.searchResultCtrl.paging), {}, {
          currentPage: action.payload.currentPage
        })
      })
    });
  },
  // １ページの表示件数を変更
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResultCtrl: _objectSpread(_objectSpread({}, state.searchResultCtrl), {}, {
        paging: _objectSpread(_objectSpread({}, state.searchResultCtrl.paging), {}, {
          currentPage: 0,
          viewNum: action.payload.viewNum
        })
      })
    });
  },
  // 監査対象事業一覧
  [TYPES.GO_MAIN]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        dispContent: CONTENTS.SEARCH
      }),
      doSearch: action.payload.doSearch,
      reload: action.payload.doSearch
    });
  },
  // 監査対象事業登録
  [TYPES.GO_REGISTER]: (state, action) => {
    const tmpKansaInfo = action.payload.kansaInfo;
    tmpKansaInfo.kansaTgtNendo = String(tmpKansaInfo.kansaTgtNendo);
    return _objectSpread(_objectSpread({}, state), {}, {
      kansaInfo: tmpKansaInfo,
      containerInfo: {
        dispContent: CONTENTS.REGISTER
      }
    });
  },
  // 組織名の表示切替
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    let newSearchResult = JSON.parse(JSON.stringify(state.searchResultCtrl.searchResult)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResultCtrl: _objectSpread(_objectSpread({}, state.searchResultCtrl), {}, {
        searchResult: newSearchResult,
        showAll: action.payload.showAll
      })
    });
  },
  // 行データ削除チェックボックスの状態変更
  [TYPES.CHANGE_DELETE_CHECK_BOX]: (state, action) => {
    const {
      checked,
      key
    } = action.payload;
    const newDeleteCheckBoxList = Object.assign({}, state.deleteCheckBoxList);
    if (checked) {
      newDeleteCheckBoxList[key] = checked;
    } else {
      delete newDeleteCheckBoxList[key];
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      deleteCheckBoxList: newDeleteCheckBoxList,
      reload: true
    });
  },
  // 行データ削除実行
  [TYPES.DELETE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResultCtrl: _objectSpread(_objectSpread({}, state.searchResultCtrl), {}, {
        searchResult: action.payload.searchResult,
        paging: Object.assign({}, INIT_STATE.searchResultCtrl.paging)
      })
    });
  },
  // 責任者／担当者選択
  [TYPES.SET_USERS]: (state, action) => {
    if (action.payload.user === undefined) {
      return _objectSpread({}, state);
    }
    const newSearchResultCtrl = JSON.parse(JSON.stringify(state.searchResultCtrl));
    const {
      kaishaCd,
      shainId,
      shainNm
    } = action.payload.user;
    const userKey = kaishaCd + ',' + shainId;
    const newInsertDataList = Object.assign({}, state.insertDataList);
    const newDeleteDataList = Object.assign({}, state.deleteDataList);
    const kansaChiefCheckBox = Object.assign({}, state.selectCtrl.kansaChiefCheckBox);
    const kansaTantoCheckBox = Object.assign({}, state.selectCtrl.kansaTantoCheckBox);
    const hikansaChiefCheckBox = Object.assign({}, state.selectCtrl.hikansaChiefCheckBox);
    const hikansaTantoCheckBox = Object.assign({}, state.selectCtrl.hikansaTantoCheckBox);

    // 更新対象行取得処理
    const getUpdateRow = function (key) {
      const [nendo, jigyoId] = key.split(',');
      for (let rowIndex = 0; rowIndex < newSearchResultCtrl.searchResult.length; rowIndex++) {
        if (newSearchResultCtrl.searchResult[rowIndex].kansaTgtNendo === nendo && newSearchResultCtrl.searchResult[rowIndex].kansaTgtJigyoId === jigyoId) {
          return {
            nendo,
            jigyoId,
            rowIndex
          };
        }
      }
    };

    // 責任者／担当者情報設定処理
    const setData = function (nendo, jigyoId, kaishaCd, shainId, tantoKbn) {
      return {
        kansaTgtNendo: nendo,
        kansaTgtJigyoId: jigyoId,
        tantoshaKaishaCd: kaishaCd,
        tantoshaShainId: shainId,
        tantoKbn: tantoKbn
      };
    };

    // 削除対象担当者の位置(会社CDと社員IDより、担当者のリスト中の位置を調べる)
    let tantoIndex = 0;

    // 監査部門責任者に選択されたユーザを追加する。
    for (let key in kansaChiefCheckBox) {
      const {
        nendo,
        jigyoId,
        rowIndex
      } = getUpdateRow(key);
      newSearchResultCtrl.searchResult[rowIndex].kansabumonChiefName = shainNm;
      newSearchResultCtrl.searchResult[rowIndex].kansabumonChiefUser = userKey;

      // 監査部門責任者情報を設定する。
      const kansabumonChief = setData(nendo, jigyoId, kaishaCd, shainId, _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_1);

      // 検索時の監査部門責任者に登録されていないユーザの場合のみ追加する。
      if (newSearchResultCtrl.searchResult[rowIndex].kansabumonChiefSave !== userKey) {
        if (!(key in newInsertDataList)) {
          newInsertDataList[key] = attachProperty();
        }
        newInsertDataList[key].kansabumonChief = kansabumonChief;
      }

      // 登録した監査部門責任者が削除情報に存在した場合、削除情報から削除する。
      if (key in newDeleteDataList) {
        if (equals(newDeleteDataList[key].kansabumonChief, kansabumonChief)) {
          newDeleteDataList[key].kansabumonChief = null;
        }
      }
    }

    // 監査部門担当者に選択されたユーザを追加する。
    for (let key in kansaTantoCheckBox) {
      const {
        nendo,
        jigyoId,
        rowIndex
      } = getUpdateRow(key);

      // 検索時に監査部門担当者が空の場合、設定先がnullなので空配列を設定する。
      if (null === newSearchResultCtrl.searchResult[rowIndex].kansabumonTantoName) {
        newSearchResultCtrl.searchResult[rowIndex].kansabumonTantoName = [];
        newSearchResultCtrl.searchResult[rowIndex].kansabumonTantoList = [];
      }

      // 現在表示されていないユーザの場合、表示対象のリストに追加する。
      if (-1 === newSearchResultCtrl.searchResult[rowIndex].kansabumonTantoList.indexOf(userKey)) {
        newSearchResultCtrl.searchResult[rowIndex].kansabumonTantoName.push(shainNm);
        newSearchResultCtrl.searchResult[rowIndex].kansabumonTantoList.push(userKey);
      }

      // 監査部門担当者情報を設定する。
      const kansabumonTanto = setData(nendo, jigyoId, kaishaCd, shainId, _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_2);

      // 検索時の監査部門担当者に登録されていないユーザの場合のみ追加する。
      if (null !== newSearchResultCtrl.searchResult[rowIndex].kansabumonTantoSave) {
        if (-1 === newSearchResultCtrl.searchResult[rowIndex].kansabumonTantoSave.indexOf(userKey)) {
          if (!(key in newInsertDataList)) {
            newInsertDataList[key] = attachProperty();
          }
          if (getRowIndex(newInsertDataList[key].kansabumonTantoList, kansabumonTanto) === -1) {
            newInsertDataList[key].kansabumonTantoList.push(kansabumonTanto);
          }
        }
      } else {
        if (!(key in newInsertDataList)) {
          newInsertDataList[key] = attachProperty();
        }
        if (getRowIndex(newInsertDataList[key].kansabumonTantoList, kansabumonTanto) === -1) {
          newInsertDataList[key].kansabumonTantoList.push(kansabumonTanto);
        }
      }

      // 登録した監査部門担当者が削除情報に存在した場合、削除情報から削除する。
      if (key in newDeleteDataList) {
        tantoIndex = getRowIndex(newDeleteDataList[key].kansabumonTantoList, kansabumonTanto);
        if (-1 !== tantoIndex) {
          newDeleteDataList[key].kansabumonTantoList.splice(tantoIndex, 1);
        }
      }
    }

    // 被監査部門責任者に選択されたユーザを追加する。
    for (let key in hikansaChiefCheckBox) {
      const {
        nendo,
        jigyoId,
        rowIndex
      } = getUpdateRow(key);
      newSearchResultCtrl.searchResult[rowIndex].hikansabumonChiefName = shainNm;
      newSearchResultCtrl.searchResult[rowIndex].hikansabumonChiefUser = userKey;

      // 被監査部門責任者情報を設定する。
      const hikansabumonChief = setData(nendo, jigyoId, kaishaCd, shainId, _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_3);

      // 検索時の被監査部門責任者に登録されていないユーザの場合のみ追加する。
      if (newSearchResultCtrl.searchResult[rowIndex].hikansabumonChiefSave !== userKey) {
        if (!(key in newInsertDataList)) {
          newInsertDataList[key] = attachProperty();
        }
        newInsertDataList[key].hikansabumonChief = hikansabumonChief;
      }

      // 登録した被監査部門責任者が削除情報に存在した場合、削除情報から削除する。
      if (key in newDeleteDataList) {
        if (equals(newDeleteDataList[key].hikansabumonChief, hikansabumonChief)) {
          newDeleteDataList[key].hikansabumonChief = null;
        }
      }
    }

    // 被監査部門担当者に選択されたユーザを追加する。
    for (let key in hikansaTantoCheckBox) {
      const {
        nendo,
        jigyoId,
        rowIndex
      } = getUpdateRow(key);

      // 検索時に監査部門担当者が空の場合、設定先がnullなので空配列を設定する。
      if (null === newSearchResultCtrl.searchResult[rowIndex].hikansabumonTantoName) {
        newSearchResultCtrl.searchResult[rowIndex].hikansabumonTantoName = [];
        newSearchResultCtrl.searchResult[rowIndex].hikansabumonTantoList = [];
      }

      // 現在表示されていないユーザの場合、表示対象のリストに追加する。
      if (-1 === newSearchResultCtrl.searchResult[rowIndex].hikansabumonTantoList.indexOf(userKey)) {
        newSearchResultCtrl.searchResult[rowIndex].hikansabumonTantoName.push(shainNm);
        newSearchResultCtrl.searchResult[rowIndex].hikansabumonTantoList.push(userKey);
      }

      // 監査部門担当者情報を設定する。
      const hikansabumonTanto = setData(nendo, jigyoId, kaishaCd, shainId, _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_4);

      // 検索時の監査部門担当者に登録されていないユーザの場合のみ追加する。
      if (null !== newSearchResultCtrl.searchResult[rowIndex].hikansabumonTantoSave) {
        if (-1 === newSearchResultCtrl.searchResult[rowIndex].hikansabumonTantoSave.indexOf(userKey)) {
          if (!(key in newInsertDataList)) {
            newInsertDataList[key] = attachProperty();
          }
          if (getRowIndex(newInsertDataList[key].hikansabumonTantoList, hikansabumonTanto) === -1) {
            newInsertDataList[key].hikansabumonTantoList.push(hikansabumonTanto);
          }
        }
      } else {
        if (!(key in newInsertDataList)) {
          newInsertDataList[key] = attachProperty();
        }
        if (getRowIndex(newInsertDataList[key].hikansabumonTantoList, hikansabumonTanto) === -1) {
          newInsertDataList[key].hikansabumonTantoList.push(hikansabumonTanto);
        }
      }

      // 登録した監査部門担当者が削除情報に存在した場合、削除情報から削除する。
      if (key in newDeleteDataList) {
        tantoIndex = getRowIndex(newDeleteDataList[key].hikansabumonTantoList, hikansabumonTanto);
        if (-1 !== tantoIndex) {
          newDeleteDataList[key].hikansabumonTantoList.splice(tantoIndex, 1);
        }
      }
    }

    // 全てのチェックボックスの状態をOFFに設定する。
    const newSelectkansaChiefCheckBoxStatus = Object.assign({}, state.selectkansaChiefCheckBoxStatus);
    const checkOffList = {};
    Object.keys(newSelectkansaChiefCheckBoxStatus).forEach(function (value) {
      checkOffList[value] = false;
    });

    // 無効化した登録情報を削除情報リスト、登録情報リストより削除する。
    sweep(newDeleteDataList);
    sweep(newInsertDataList);
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResultCtrl: newSearchResultCtrl,
      selectCtrl: {
        kansaChiefCheckBox: {},
        kansaTantoCheckBox: {},
        hikansaChiefCheckBox: {},
        hikansaTantoCheckBox: {},
        kansaChiefCheckBoxStatus: checkOffList,
        kansaTantoCheckBoxStatus: checkOffList,
        hikansaChiefCheckBoxStatus: checkOffList,
        hikansaTantoCheckBoxStatus: checkOffList
      },
      insertDataList: newInsertDataList,
      deleteDataList: newDeleteDataList
    });
  },
  // 責任者／担当者 選択
  [TYPES.SELECT_USER]: (state, action) => {
    const key = action.payload.kansaTgtNendo + ',' + action.payload.kansaTgtJigyoId;
    const tantoKbn = action.payload.tantoKbn;
    let newCheckBox = null;
    let newCheckBoxStatus = null;
    switch (tantoKbn) {
      // 監査部門責任者
      case _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_1:
        newCheckBox = Object.assign({}, state.selectCtrl.kansaChiefCheckBox);
        newCheckBoxStatus = Object.assign({}, state.selectCtrl.kansaChiefCheckBoxStatus);
        break;

      // 監査部門担当者
      case _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_2:
        newCheckBox = Object.assign({}, state.selectCtrl.kansaTantoCheckBox);
        newCheckBoxStatus = Object.assign({}, state.selectCtrl.kansaTantoCheckBoxStatus);
        break;

      // 被監査部門責任者
      case _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_3:
        newCheckBox = Object.assign({}, state.selectCtrl.hikansaChiefCheckBox);
        newCheckBoxStatus = Object.assign({}, state.selectCtrl.hikansaChiefCheckBoxStatus);
        break;

      // 被監査部門担当者
      case _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_4:
        newCheckBox = Object.assign({}, state.selectCtrl.hikansaTantoCheckBox);
        newCheckBoxStatus = Object.assign({}, state.selectCtrl.hikansaTantoCheckBoxStatus);
        break;

      // 到達不能
      default:
        break;
    }

    // チェックボックスがONになっている項目を保存する。OFFになった場合は削除する。
    if (key in newCheckBox) {
      delete newCheckBox[key];
    } else {
      newCheckBox[key] = true;
    }

    // ステータス反転
    newCheckBoxStatus[key] = !newCheckBoxStatus[key];
    switch (tantoKbn) {
      // 監査部門責任者
      case _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_1:
        return _objectSpread(_objectSpread({}, state), {}, {
          selectCtrl: _objectSpread(_objectSpread({}, state.selectCtrl), {}, {
            kansaChiefCheckBox: newCheckBox,
            kansaChiefCheckBoxStatus: newCheckBoxStatus
          }),
          reload: false
        });

      // 監査部門担当者
      case _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_2:
        return _objectSpread(_objectSpread({}, state), {}, {
          selectCtrl: _objectSpread(_objectSpread({}, state.selectCtrl), {}, {
            kansaTantoCheckBox: newCheckBox,
            kansaTantoCheckBoxStatus: newCheckBoxStatus
          }),
          reload: false
        });

      // 被監査部門責任者
      case _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_3:
        return _objectSpread(_objectSpread({}, state), {}, {
          selectCtrl: _objectSpread(_objectSpread({}, state.selectCtrl), {}, {
            hikansaChiefCheckBox: newCheckBox,
            hikansaChiefCheckBoxStatus: newCheckBoxStatus
          }),
          reload: false
        });

      // 被監査部門担当者
      case _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_4:
        return _objectSpread(_objectSpread({}, state), {}, {
          selectCtrl: _objectSpread(_objectSpread({}, state.selectCtrl), {}, {
            hikansaTantoCheckBox: newCheckBox,
            hikansaTantoCheckBoxStatus: newCheckBoxStatus
          }),
          reload: false
        });

      // 到達不能
      default:
        return {};
    }
  },
  // 責任者／担当者 削除
  [TYPES.DELETE_USER]: (state, action) => {
    const newSearchResultCtrl = JSON.parse(JSON.stringify(state.searchResultCtrl));
    const {
      kansaTgtNendo,
      kansaTgtJigyoId,
      user,
      tantoKbn
    } = action.payload;
    const key = kansaTgtNendo + ',' + kansaTgtJigyoId;
    const [kaishaCd, shainId] = user.split(',');
    const newInsertDataList = Object.assign({}, state.insertDataList);
    const newDeleteDataList = Object.assign({}, state.deleteDataList);

    // 監査事業年度、監査対象事業IDが一致するデータより、削除アイコンが押下された行を削除する。
    let rowIndex = null;
    for (let i = 0; i < newSearchResultCtrl.searchResult.length; i++) {
      if (newSearchResultCtrl.searchResult[i].kansaTgtNendo === kansaTgtNendo && newSearchResultCtrl.searchResult[i].kansaTgtJigyoId === kansaTgtJigyoId) {
        // 対象となる行を特定。
        rowIndex = i;
      }
    }

    // 削除対象ユーザ情報を設定する。(担当者区分のみ、後続処理で決定)
    const deleteUser = {
      kansaTgtNendo: kansaTgtNendo,
      kansaTgtJigyoId: kansaTgtJigyoId,
      tantoshaKaishaCd: kaishaCd,
      tantoshaShainId: shainId,
      tantoKbn: null
    };

    // 削除対象担当者の位置(会社CDと社員IDより、担当者のリスト中の位置を調べる)
    let tantoIndex = 0;

    // 担当者区分に応じた削除処理を行う。
    switch (tantoKbn) {
      // 監査部門責任者
      case _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_1:
        // 担当者区分設定、監査部門責任者
        deleteUser.tantoKbn = _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_1;

        // 表示中の監査部門責任者名を削除する。
        newSearchResultCtrl.searchResult[rowIndex].kansabumonChiefName = null;

        // 検索時の監査部門責任者が削除された場合、削除対象リストに登録する。
        if (newSearchResultCtrl.searchResult[rowIndex].kansabumonChiefSave === user) {
          if (!(key in newDeleteDataList)) {
            newDeleteDataList[key] = attachProperty();
          }
          newDeleteDataList[key].kansabumonChief = deleteUser;
        }

        // 削除した監査部門責任者が登録情報に存在した場合、登録情報から削除する。
        if (key in newInsertDataList) {
          if (equals(newInsertDataList[key].kansabumonChief, deleteUser)) {
            newInsertDataList[key].kansabumonChief = null;
          }
        }
        break;

      // 監査部門担当者
      case _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_2:
        // 担当者区分設定、監査部門担当者
        deleteUser.tantoKbn = _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_2;

        // 表示中の監査部門担当者名のリストから削除された担当者名を削除する。
        tantoIndex = newSearchResultCtrl.searchResult[rowIndex].kansabumonTantoList.indexOf(user);
        newSearchResultCtrl.searchResult[rowIndex].kansabumonTantoName.splice(tantoIndex, 1);
        newSearchResultCtrl.searchResult[rowIndex].kansabumonTantoList.splice(tantoIndex, 1);

        // 検索時の監査部門担当者のリストに登録されていた担当者の場合、削除対象リストに登録する。
        if (null !== newSearchResultCtrl.searchResult[rowIndex].kansabumonTantoSave) {
          if (-1 !== newSearchResultCtrl.searchResult[rowIndex].kansabumonTantoSave.indexOf(user)) {
            if (!(key in newDeleteDataList)) {
              newDeleteDataList[key] = attachProperty();
            }
            newDeleteDataList[key].kansabumonTantoList.push(deleteUser);
          }
        }

        // 削除した監査部門担当者が登録情報に存在した場合、登録情報から削除する。
        if (key in newInsertDataList) {
          tantoIndex = getRowIndex(newInsertDataList[key].kansabumonTantoList, deleteUser);
          if (-1 !== tantoIndex) {
            if (!(key in newDeleteDataList)) {
              newDeleteDataList[key] = attachProperty();
            }
            newInsertDataList[key].kansabumonTantoList.splice(tantoIndex, 1);
          }
        }
        break;

      // 被監査部門責任者
      case _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_3:
        // 担当者区分設定、被監査部門責任者
        deleteUser.tantoKbn = _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_3;

        // 表示中の被監査部門責任者名を削除する。
        newSearchResultCtrl.searchResult[rowIndex].hikansabumonChiefName = null;

        // 検索時の被監査部門責任者が削除された場合、削除対象リストに登録する。
        if (newSearchResultCtrl.searchResult[rowIndex].hikansabumonChiefSave === user) {
          if (!(key in newDeleteDataList)) {
            newDeleteDataList[key] = attachProperty();
          }
          newDeleteDataList[key].hikansabumonChief = deleteUser;
        }

        // 削除した被監査部門責任者が登録情報に存在した場合、登録情報から削除する。
        if (key in newInsertDataList) {
          if (equals(newInsertDataList[key].hikansabumonChief, deleteUser)) {
            newInsertDataList[key].hikansabumonChief = null;
          }
        }
        break;

      // 被監査部門担当者
      case _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_4:
        // 担当者区分設定、被監査部門担当者
        deleteUser.tantoKbn = _CodeConsts.CODE.KANSA_TANTO_KBN.CODE_4;

        // 表示中の被監査部門担当者名のリストから削除された担当者名を削除する。
        tantoIndex = newSearchResultCtrl.searchResult[rowIndex].hikansabumonTantoList.indexOf(user);
        newSearchResultCtrl.searchResult[rowIndex].hikansabumonTantoName.splice(tantoIndex, 1);
        newSearchResultCtrl.searchResult[rowIndex].hikansabumonTantoList.splice(tantoIndex, 1);

        // 検索時の被監査部門担当者のリストに登録されていた担当者の場合、削除対象リストに登録する。
        if (null !== newSearchResultCtrl.searchResult[rowIndex].hikansabumonTantoSave) {
          if (-1 !== newSearchResultCtrl.searchResult[rowIndex].hikansabumonTantoSave.indexOf(user)) {
            if (!(key in newDeleteDataList)) {
              newDeleteDataList[key] = attachProperty();
            }
            newDeleteDataList[key].hikansabumonTantoList.push(deleteUser);
          }
        }

        // 削除した被監査部門担当者情報が登録情報に存在した場合、登録情報から削除する。
        if (key in newInsertDataList) {
          tantoIndex = getRowIndex(newInsertDataList[key].hikansabumonTantoList, deleteUser);
          if (-1 !== tantoIndex) {
            newInsertDataList[key].hikansabumonTantoList.splice(tantoIndex, 1);
          }
        }
        break;

      // 到達不能
      default:
        break;
    }

    // 無効化した登録情報を削除情報リスト、登録情報リストより削除する。
    sweep(newDeleteDataList);
    sweep(newInsertDataList);
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResultCtrl: newSearchResultCtrl,
      insertDataList: newInsertDataList,
      deleteDataList: newDeleteDataList,
      reload: true
    });
  },
  // 年度選択変更
  [TYPES.CHANGE_NENDO]: (state, action) => {
    const {
      nendo,
      theme
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
        kansaTgtNendo: nendo,
        kansaTgtTheme: theme
      }),
      selectNendo: _objectSpread(_objectSpread({}, state.selectNendo), {}, {
        kansaTgtNendo: nendo,
        kansaTgtTheme: theme
      })
    });
  },
  // 初期値を返却
  [TYPES.SET_INITIAL_VALUE]: (state, action) => {
    const {
      nendo,
      theme,
      preparation
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
        kansaTgtNendo: nendo,
        kansaTgtTheme: theme
      }),
      selectNendo: {
        kansaTgtNendo: nendo,
        kansaTgtTheme: theme,
        preparation: preparation
      }
    });
  },
  // 初期状態にする
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE),
  [TYPES.APPLY_SHARE_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), action.payload.searchConditions)
  }),
  [TYPES.CHANGE_RELOAD]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    reload: action.payload.reload
  })
}, INIT_STATE);